/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-05 16:24:13
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-17 20:18:04
 * @FilePath: \mpc-monorepo\features\common\src\components\CellDescriptions\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Button, Popover, Descriptions } from '@bedrock/components';
import React, { useMemo } from 'react';
import { DescriptionsProps } from '@bedrock/components/lib/Descriptions';
import { DescriptionsItemType } from '@bedrock/components/lib/Descriptions/Item';
import { PopoverProps } from '@bedrock/components/lib/Popover';
import { ChevronRight } from '@bedrock/icons-react';
import classNames from 'classnames';
import classNamesBind from 'classnames/bind';
import styles from './index.less';
import { useScreenAdapterContext } from '@bedrock/eed-react';
import { EllipsisTooltip } from '#components/EllipsisTooltip';

const cx = classNamesBind.bind(styles);

const CustomCellDescriptions: React.FC<DescriptionsProps> = (props) => {
  return (
    <Descriptions
      {...props}
      className={classNames(cx('custom-cell-descriptions', {'custom-cell-descriptions-no-colon': props.colon === false}), props.className)}
    />
  );
};

export interface PopoverDescriptionsProps {
  descriptionsProps?: DescriptionsProps;
  popoverProps?: PopoverProps;
}

export const PopoverDescriptions = (props: PopoverDescriptionsProps) => {
  return (
    <Popover
      content={<CustomCellDescriptions {...props?.descriptionsProps} />}
      {...props?.popoverProps}
      overlayClassName={classNames(
        cx('popover-cell-descriptions'),
        props?.popoverProps?.overlayClassName
      )}
      placement={props?.popoverProps?.placement || 'bottomLeft'}
    >
      <Button
        suffixIcon={<ChevronRight />}
        size="xSmall"
        className={'text-[12px] leading-[18px] h-[20px] rounded-[4px]'}
      >
        +{props?.descriptionsProps?.items?.length}
      </Button>
    </Popover>
  );
};

export interface CellDescriptionsProps
  extends Omit<DescriptionsProps, 'items'> {
  items: DescriptionsItemType[];
  maxDisplayCount?: number;
  matchFn?: (item: DescriptionsItemType, index: number) => boolean;
  otherLabel?: string;
  popoverProps?: PopoverProps;
}

export const CellDescriptions: React.FC<CellDescriptionsProps> = ({
  items = [],
  maxDisplayCount = 2,
  matchFn,
  otherLabel = '其他',
  popoverProps,
  ...restProps
}) => {
  const { viewBase } = useScreenAdapterContext();

  const displayedIndices = useMemo(() => {
    if (items.length === 0) return [];

    if (matchFn) {
      const matchedIndex = items.findIndex((item, index) =>
        matchFn(item, index)
      );
      if (matchedIndex !== -1) return [matchedIndex];
    }

    return Array.from(
      { length: Math.min(maxDisplayCount, items.length) },
      (_, i) => i
    );
  }, [items, maxDisplayCount, matchFn]);

  const displayedItems = useMemo(
    () => displayedIndices.map((index) => items[index]),
    [items, displayedIndices]
  );
  const remainingItems = useMemo(
    () => items.filter((_, index) => !displayedIndices.includes(index)),
    [items, displayedIndices]
  );

  if (items.length === 0) return null;

  const finalItems: DescriptionsItemType[] = [
    ...displayedItems,
    ...(remainingItems.length > 0
      ? [
          {
            label: otherLabel,
            children: (
              <PopoverDescriptions
                descriptionsProps={{
                  column: 1,
                  labelStyle: {
                    maxWidth: 200 * viewBase,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                  ...restProps,
                  items: remainingItems,
                }}
                popoverProps={popoverProps}
              />
            ),
          } as DescriptionsItemType,
        ]
      : []),
  ].map(n => {
    return {
      ...n,
      label: n.label ? <span title={n.label?.toString() || ''}>{n.label}</span> : null,
      children: typeof n.children === 'string' ? <EllipsisTooltip clamp={1} text={n.children} /> : n.children,
    }
  });

  return (
    <CustomCellDescriptions column={1} {...restProps} items={finalItems} />
  );
};
